import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MaterialCssVarsService } from 'angular-material-css-vars';
import { SelfThemerService } from './lib-services/self-themer.service';
import { Theme } from './models/colors';

@Component({
  selector: 'lib-wg-themer',
  templateUrl: './wg-themer.component.html',
  styleUrls: [
    './wg-themer.component.scss'
  ]
})
export class WgThemerComponent implements AfterViewInit {

  constructor(
    public xvars : SelfThemerService) {
   }
   setTheme(theme: Theme){
    this.xvars.setTheme(theme.value);
   }

  ngAfterViewInit(): void {
    //this.setTheme(this.theme$[0]);
  }
  // updateTheme(theme: Theme) {
  //   const element = this.getElement();

  //   // project properties onto the element
  //   for (const key in theme.properties) {
  //     element.style.setProperty(key, theme.properties[key]);
  //   }

  //   // remove old theme
  //   for (const name of this._themeService.theme) {
  //     element.classList.remove(`${name}-theme`);
  //   }

  //   // alias element with theme name
  //   element.classList.add(`${theme.name}-theme`);
  // }


}
